import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import MiniBar from 'Components/atoms/MiniBar/MiniBar';

/** Shared across the grid via AG Grid `context` so every bar uses one scale. */
export interface InventoryGridContext {
    /** Largest value in the currently-barred column, for proportional fills. */
    maxBarValue: number;
}

/**
 * Renders a count as a number plus a mini-bar proportional to the largest value
 * in the barred column for the current view (supplied via grid `context`). Used
 * for the headline count of each grouping mode (devices / titles).
 */
const CountBarCellRenderer: React.FC<ICellRendererParams> = ({ value, context }) => {
    const count = typeof value === 'number' ? value : Number(value) || 0;
    const max = (context as InventoryGridContext)?.maxBarValue ?? count;
    return (
        <div className="inventory-bar-cell">
            <MiniBar value={count} max={max} />
        </div>
    );
};

export default CountBarCellRenderer;
